/* eslint-disable no-unused-vars */
import NamePage from "./steps/NamePage";
import GenderPage from "./steps/GenderPage";
import TypeOfDietPage from "./steps/TypeOfDietPage";
import ProtocolSelectionPage from "./steps/ProtocolSelectionPage";
import NicknamePage from "./steps/NicknamePage";
import PhonePages from "./steps/PhonePages";
import WeightPage from "./steps/WeightPage";
import WeightGoalsPage from "./steps/WeightGoalsPage";
import HeightPage from "./steps/HeightPage";
import BirthDatePage from "./steps/BirthDatePage";
import AbdominalCircumferencePage from "./steps/AbdominalCircumferencePage";
import HipCircunferencePace from "./steps/HipCircunferencePace";
import WaistCircumferencePage from "./steps/WaistCircumferencePage";
import AvatarPages from "./steps/AvatarPages";
import ImpedimentsPhysicalPage from "./steps/ImpedimentsPhysicalPage";
import SleepDurationPage from "./steps/SleepDurationPage";
import IntestinalFuncionalityPage from "./steps/IntestinalFuncionalityPage";
import WhereYouLivePage from "./steps/WhereYouLivePage";
import CookingPreferencesPage from "./steps/CookingPreferencesPage";
import EatingOutPage from "./steps/EatingOutPage";
import MotivationPage from "./steps/MotivationPage";
import HobbyPage from "./steps/HobbyPage";
import WeHaveFinished from "./steps/WeHaveFinished";
import PhysicalPersonalStep from "./steps/PhysicalPersonalStep";
import PublicProfileStep from "./steps/PublicProfileStep";
import RemovedOnboardingStep from "./steps/RemovedOnboardingStep";
const steps = [
  PhysicalPersonalStep,
  PublicProfileStep,
  // 3 and 4 were "Cibi non graditi" and "Obiettivi", taken out of onboarding
  // (client, 14/09/2026). They keep their positions so the pages after them keep
  // their step numbers, and step 5 stays the preferences screen.
  RemovedOnboardingStep,
  RemovedOnboardingStep,
  TypeOfDietPage,
  GenderPage,
  ProtocolSelectionPage,
  NicknamePage,
  PhonePages,
  WeHaveFinished,
  WeightPage,
  WeightGoalsPage,
  HeightPage,
  BirthDatePage,
  AbdominalCircumferencePage,
  HipCircunferencePace,
  WaistCircumferencePage,
  AvatarPages,
  ImpedimentsPhysicalPage,
  SleepDurationPage,
  IntestinalFuncionalityPage,
  WhereYouLivePage,
  CookingPreferencesPage,
  EatingOutPage,
  MotivationPage,
  HobbyPage,
];

export default steps;
